/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class patientindex extends IceEntity {
  patient_index_key: string = "";
  trans_account: string = "";
  first_name: string = "";
  last_name: string = "";
  sex: string = "";
  dob: any = NaN;
  dob_utc: any = NaN;
  dod: any = NaN;
  ssn_fedid_num: string = "";
  city: string = "";
  postal_code: string = "";
  identification_code1: string = "";
  identification_code2: string = "";
  identification_code3: string = "";
  additional_name: string = "";
  suffix: string = "";
  merged_trans_account: string = "";
  communication_number1: string = "";
  communication_number2: string = "";
  communication_number3: string = "";
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  gettablename(): string {
        return "PATIENT_INDEX";
  }

  getdisplayname(): string {
    let disply = this.first_name;

    if (disply.length > 0)
      disply += " " + this.last_name;

    if (this.suffix.length > 0)
      disply += ", " + this.suffix;

    return disply;
  }

}
